export default {
  name: 'marking--treeMrkAggregation',
  apiService: 'shoes',
  apiPath: '/admin/mrk/func/aggr',
  urlParamName: 'marking--treeMrkAggregation',
};